export default __webpack_public_path__ + "static/media/MatsRunners.eecd7e20.png";